import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  color: ${Colors.Blue50};
  ${FontWeights.Regular};
  ${Typography.Body};
  flex-shrink: 0;
  display: flex;
  gap: ${Spacing['3XS']};
  cursor: pointer;

  ${Media.Tablet`
    margin-bottom: 0

    `}

  ${Media.Phone`
    align-items: center;
    margin-bottom: 0;
  `}
`
